import type { ChangeEvent } from 'react';

import Button from '../components/common/Button';
import type { ErrorMessage } from '../helpers/type';
import PasswordInputField from './PasswordInputField';

interface ResetPasswordFormProps {
  password: string;
  confirmPassword: string;
  passwordError: ErrorMessage;
  confirmPasswordError: ErrorMessage;
  passwordBorder: string;
  confirmPasswordBorder: string;
  loading: boolean;
  onInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  title: string;
  subtitle: string;
  passwordLabel: string;
  confirmPasswordLabel: string;
  submitLabel: string;
}

const ResetPasswordForm = ({
  password,
  confirmPassword,
  passwordError,
  confirmPasswordError,
  passwordBorder,
  confirmPasswordBorder,
  loading,
  onInputChange,
  onSubmit,
  title,
  subtitle,
  passwordLabel,
  confirmPasswordLabel,
  submitLabel,
}: ResetPasswordFormProps) => (
  <div className="w-full max-w-md py-10">
    <div className="text-center mb-8">
      <div className="flex items-center justify-center mb-4"></div>
      <h2 className="text-3xl font-bold text-gray-900">{title}</h2>
      <p className="text-gray-600 mt-2">{subtitle}</p>
    </div>

    <form onSubmit={onSubmit} className="space-y-6">
      <PasswordInputField
        id="password"
        name="password"
        label={passwordLabel}
        value={password}
        error={passwordError}
        border={passwordBorder}
        onChange={onInputChange}
      />
      <PasswordInputField
        id="confirmPassword"
        name="confirmPassword"
        label={confirmPasswordLabel}
        value={confirmPassword}
        error={confirmPasswordError}
        border={confirmPasswordBorder}
        onChange={onInputChange}
      />
    </form>

    <div className="py-6">
      <Button
        variant="primary"
        size="lg"
        className="w-full"
        loading={loading}
        onClick={onSubmit}
      >
        {submitLabel}
      </Button>
    </div>
  </div>
);

export default ResetPasswordForm;
